import { render } from "./impressumSite.vue?vue&type=template&id=6ba27bf9"
import script from "./impressumSite.vue?vue&type=script&lang=js"
export * from "./impressumSite.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__